import { render, staticRenderFns } from "./monitoreOverview.vue?vue&type=template&id=67f3cfb1&scoped=true&"
import script from "./monitoreOverview.vue?vue&type=script&lang=js&"
export * from "./monitoreOverview.vue?vue&type=script&lang=js&"
import style0 from "./monitoreOverview.vue?vue&type=style&index=0&id=67f3cfb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f3cfb1",
  null
  
)

export default component.exports